export default "__VITE_ASSET__ac0b923e__"